import moment from 'moment';

export const getBufferdTimeString = (time: string, minutes: number) => {
  const buffered = moment(time, 'HH:mm:ss')
    .add(minutes, 'minutes')
    .format('HH:mm:ss');
  return buffered;
};
